export default __webpack_public_path__ + "static/media/3-bg.2ea21a07.svg";